import React from 'react';
import { styled } from '@mui/material/styles';

interface ResizeHandleProps {
  isResizing: boolean;
  onMouseDown: (e: React.MouseEvent) => void;
}

// Styled component for the resize handle
const StyledResizeHandle = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: 0,
  bottom: 0,
  right: '-5px',
  width: '10px',
  cursor: 'col-resize',
  zIndex: 1,
  transition: 'background-color 0.2s ease',
  '&:hover': {
    backgroundColor: theme.palette.action.hover
  },
  '&.resizing': {
    backgroundColor: theme.palette.primary.main
  }
}));

export const ResizeHandle: React.FC<ResizeHandleProps> = ({
  isResizing,
  onMouseDown
}) => {
  return (
    <StyledResizeHandle
      className={isResizing ? 'resizing' : ''}
      onMouseDown={onMouseDown}
    />
  );
};
